import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectNotes,
    selectStrategy,
    setNotes,
    setStrategy,
    setPrompts, selectPrompts
} from "../../sessionWatchSlice";
import "./Text.css"; // import stylesheet

export const Text = () => {
    const notesSaved = useSelector(selectNotes);
    const strategySaved = useSelector(selectStrategy);
    const promptSaved = useSelector(selectPrompts);
    const dispatch = useDispatch();

    useEffect(() => {
        const savedStrategies = JSON.parse(localStorage.getItem("strategies")) || "";
        dispatch(setStrategy(savedStrategies));
    }, [dispatch]);

    return (
        <div className="text-container">
            <div className="text-row">
                <div className="text-section">
                    <label htmlFor="notes" className="text-label">
                        Notes
                    </label>
                    <textarea
                        onChange={(e) => dispatch(setNotes(e.target.value))}
                        id="notes"
                        className="text-area"
                        rows="5"
                        placeholder={notesSaved ? notesSaved : "Type your notes here..."}
                    />
                </div>

                <div className="text-section">
                    <label htmlFor="strategy" className="text-label">
                        Strategies
                    </label>
                    <textarea
                        onChange={(e) => dispatch(setStrategy(e.currentTarget.value))}
                        id="strategy"
                        className="text-area"
                        defaultValue={strategySaved ? strategySaved : ""}
                        rows="5"
                        placeholder={!strategySaved && "Type your strategies here..."}
                    />
                </div>
            </div>

            <div className="text-section">
                <label htmlFor="prompts" className="text-label">
                    Prompts
                </label>
                <textarea
                    onChange={(e) => dispatch(setPrompts(e.currentTarget.value))}
                    id="prompts"
                    className="text-area"
                    defaultValue={promptSaved ? promptSaved : ""}
                    rows="5"
                    placeholder={!promptSaved && "Type your prompts here..."}
                />
            </div>
        </div>
    );
};